import { CloseButton } from "@chakra-ui/close-button";
import { Box, Flex, Heading, HStack } from "@chakra-ui/layout";
import { chakra } from "@chakra-ui/system";
import * as React from "react";
import { useOkHiMessageSender } from "../hooks/useOkHiMessageSender";
import { okhiTracker } from "../OkHiTracker";
import { useOkHiIncomingMessage } from "./OkHiIncomingMessageProvider";

export function Header() {
  const { closePortal } = useOkHiMessageSender();
  const handleCloseButtonClick = () => {
    closePortal();
    okhiTracker.track("Button Tapped", {
      label: "Close Icon",
      onObject: "button",
      action: "tapclick",
    });
  };
  const message = useOkHiIncomingMessage();
  return (
    <chakra.header
      shadow="sm"
      pos="sticky"
      top="0"
      zIndex="3"
      bg="primary.500"
      left="0"
      right="0"
      width="full"
      color="highlight.500">
      <Box height="4.5rem" mx="auto" maxW="8xl">
        <Flex w="100%" h="100%" px={6} align="center" justify="space-between">
          <HStack spacing="5">
            <Heading size="md">{message?.context.companyName ?? ""}</Heading>
          </HStack>
          <CloseButton size="lg" onClick={handleCloseButtonClick} />
        </Flex>
      </Box>
    </chakra.header>
  );
}
